const AVALIACAO_DISCRIMINACOES = {
  1: {
    id: 1,
    questao_id: 1,
    opcao: '1ª',
    discriminacao:
      'Indisponibilidade de classificação ou classificação abaixo dos níveis discriminados na 2ª, 3ª ou 4ª opções a seguir.',
    resposta_gestor: true,
    pontos: -3
  },
  2: {
    id: 2,
    questao_id: 1,
    opcao: '2ª',
    discriminacao:
      "Equivalente M3 da Fitch; AMP-3 da S&P; MQ3 da Moody's; LFg3 da LFRatings; ou QG 3 Austin.",
    resposta_gestor: false,
    pontos: -1
  },
  3: {
    id: 3,
    questao_id: 1,
    opcao: '3ª',
    discriminacao:
      "Equivalente M2 da Fitch; AMP-2 da S&P; MQ2 da Moody's; LFg2 da LFRatings; ou QG 2 Austin.",
    resposta_gestor: false,
    pontos: 1
  },
  4: {
    id: 4,
    questao_id: 1,
    opcao: '4ª',
    discriminacao:
      "Nota equivalente ao M1 da Fitch; AMP-1 da S&P; MQ1 da Moody's; LFg1 da LFRatings; ou QG 1 Austin.",
    resposta_gestor: false,
    pontos: 3
  },
  5: {
    id: 5,
    questao_id: 2,
    opcao: '1ª',
    discriminacao: 'Até R$ 1 bilhão.',
    resposta_gestor: false,
    pontos: 0
  },
  6: {
    id: 6,
    questao_id: 2,
    opcao: '2ª',
    discriminacao: 'De R$ 1 bilhão a R$ 10 bilhões.',
    resposta_gestor: true,
    pontos: 1
  },
  7: {
    id: 7,
    questao_id: 2,
    opcao: '3ª',
    discriminacao: 'De R$ 10 bilhões a R$ 100 bilhões.',
    resposta_gestor: false,
    pontos: 2
  },
  8: {
    id: 8,
    questao_id: 2,
    opcao: '4ª',
    discriminacao: 'Acima de R$ 100 bilhões',
    resposta_gestor: false,
    pontos: 3
  },
  9: {
    id: 9,
    questao_id: 3,
    opcao: '1ª',
    discriminacao: 'Na hipótese de redução do AUM em mais de 10% no período avaliado.',
    resposta_gestor: true,
    pontos: 0
  },
  10: {
    id: 10,
    questao_id: 3,
    opcao: '2ª',
    discriminacao: 'Na hipótese de redução do AUM em até 10% no período avaliado.',
    resposta_gestor: false,
    pontos: 1
  },
  11: {
    id: 11,
    questao_id: 3,
    opcao: '3ª',
    discriminacao: 'Na hipótese de manutenção do AUM no período avaliado.',
    resposta_gestor: false,
    pontos: 2
  },
  12: {
    id: 12,
    questao_id: 3,
    opcao: '4ª',
    discriminacao: 'Na hipótese de elevação do AUM no período avaliado.',
    resposta_gestor: false,
    pontos: 3
  },
  13: {
    id: 13,
    questao_id: 4,
    opcao: '1ª',
    discriminacao: 'Média apurada em anos de atuação inferior a 5 anos.',
    resposta_gestor: true,
    pontos: 0
  },
  14: {
    id: 14,
    questao_id: 4,
    opcao: '2ª',
    discriminacao: 'Média apurada em anos de atuação maior ou igual a 5 e menor que 10 anos.',
    resposta_gestor: false,
    pontos: 1
  },
  15: {
    id: 15,
    questao_id: 4,
    opcao: '3ª',
    discriminacao: 'Média apurada em anos de atuação maior ou igual a 10 e menor que 15 anos.',
    resposta_gestor: false,
    pontos: 2
  },
  16: {
    id: 16,
    questao_id: 4,
    opcao: '4ª',
    discriminacao: 'Média apurada em anos de atuação maior ou igual a 15 anos.',
    resposta_gestor: false,
    pontos: 3
  },
  17: {
    id: 17,
    questao_id: 5,
    opcao: '1ª',
    discriminacao: 'Média apurada em anos de atuação inferior a 3 anos.',
    resposta_gestor: true,
    pontos: 0
  },
  18: {
    id: 18,
    questao_id: 5,
    opcao: '2ª',
    discriminacao: 'Média apurada em anos de atuação maior ou igual a 3 e menor que 6 anos.',
    resposta_gestor: false,
    pontos: 1
  },
  19: {
    id: 19,
    questao_id: 5,
    opcao: '3ª',
    discriminacao: 'Média apurada em anos de atuação maior ou igual a 6 e menor que 9 anos.',
    resposta_gestor: false,
    pontos: 2
  },
  20: {
    id: 20,
    questao_id: 5,
    opcao: '4ª',
    discriminacao: 'Média apurada em anos de atuação maior ou igual a 9 anos.',
    resposta_gestor: false,
    pontos: 3
  },
  21: {
    id: 21,
    questao_id: 6,
    opcao: '1ª',
    discriminacao: 'Formação acadêmica básica.',
    resposta_gestor: true,
    pontos: 0
  },
  22: {
    id: 22,
    questao_id: 6,
    opcao: '2ª',
    discriminacao: 'Cursos de especialização / pós-graduação (mais de 50%).',
    resposta_gestor: false,
    pontos: 1
  },
  23: {
    id: 23,
    questao_id: 6,
    opcao: '3ª',
    discriminacao: 'Mestrado, Doutorado, PhD ou CFA (mais de 50%).',
    resposta_gestor: false,
    pontos: 2
  },
  24: {
    id: 24,
    questao_id: 6,
    opcao: '4ª',
    discriminacao: 'Mestrado, Doutorado, PhD ou CFA para 100% da equipe.',
    resposta_gestor: false,
    pontos: 3
  },
  25: {
    id: 25,
    questao_id: 7,
    opcao: '1ª',
    discriminacao: 'Formação acadêmica básica.',
    resposta_gestor: true,
    pontos: 0
  },
  26: {
    id: 26,
    questao_id: 7,
    opcao: '2ª',
    discriminacao: 'Cursos de especialização / pós-graduação (apenas pessoa chave).',
    resposta_gestor: false,
    pontos: 1
  },
  27: {
    id: 27,
    questao_id: 7,
    opcao: '3ª',
    discriminacao: 'Cursos de especialização / pós-graduação (+ de 50%).',
    resposta_gestor: false,
    pontos: 2
  },
  28: {
    id: 28,
    questao_id: 7,
    opcao: '4ª',
    discriminacao: 'Mestrado, Doutorado, PhD ou CFA (+ de 50%). ',
    resposta_gestor: false,
    pontos: 3
  },
  29: {
    id: 29,
    questao_id: 8,
    opcao: '1ª',
    discriminacao: 'Não informado ou perda de membro(s) chave, sem reposição.',
    resposta_gestor: true,
    pontos: 0
  },
  30: {
    id: 30,
    questao_id: 8,
    opcao: '2ª',
    discriminacao: 'Perda de membro(s) chave, com reposição em nível inferior.',
    resposta_gestor: false,
    pontos: 1
  },
  31: {
    id: 31,
    questao_id: 8,
    opcao: '3ª',
    discriminacao:
      'Manutenção da equipe ou perda de membro(s) chave, porém com reposição em mesmo nível.',
    resposta_gestor: false,
    pontos: 2
  },
  32: {
    id: 32,
    questao_id: 8,
    opcao: '4ª',
    discriminacao: 'Ampliação do quadro, com ingresso de novos(s) membro(s) chave habilitado(s).',
    resposta_gestor: false,
    pontos: 3
  },
  33: {
    id: 33,
    questao_id: 9,
    opcao: '1ª',
    discriminacao: 'Não informado ou perda de membro(s) chave, sem reposição.',
    resposta_gestor: true,
    pontos: 0
  },
  34: {
    id: 34,
    questao_id: 9,
    opcao: '2ª',
    discriminacao: 'Perda de membro(s) chave, com reposição em nível inferior.',
    resposta_gestor: false,
    pontos: 1
  },
  35: {
    id: 35,
    questao_id: 9,
    opcao: '3ª',
    discriminacao:
      'Manutenção da equipe ou perda de membro(s) chave, porém com reposição em mesmo nível.',
    resposta_gestor: false,
    pontos: 2
  },
  36: {
    id: 36,
    questao_id: 9,
    opcao: '4ª',
    discriminacao: 'Ampliação do quadro, com ingresso de novos(s) membro(s) chave habilitado(s).',
    resposta_gestor: false,
    pontos: 3
  },
  37: {
    id: 37,
    questao_id: 10,
    opcao: '1ª',
    discriminacao: 'Elevado.',
    resposta_gestor: true,
    pontos: 0
  },
  38: {
    id: 38,
    questao_id: 10,
    opcao: '2ª',
    discriminacao: 'Moderado.',
    resposta_gestor: false,
    pontos: 1.5
  },
  39: {
    id: 39,
    questao_id: 10,
    opcao: '3ª',
    discriminacao: 'Baixo. 3',
    resposta_gestor: false,
    pontos: 3
  },
  40: {
    id: 40,
    questao_id: 11,
    opcao: '1ª',
    discriminacao: '≤ 25%',
    resposta_gestor: true,
    pontos: 0
  },
  41: {
    id: 41,
    questao_id: 11,
    opcao: '2ª',
    discriminacao: '> 25% e ≤ 50%.',
    resposta_gestor: false,
    pontos: 1
  },
  42: {
    id: 42,
    questao_id: 11,
    opcao: '3ª',
    discriminacao: '> 50% e ≤ 75%.',
    resposta_gestor: false,
    pontos: 2
  },
  43: {
    id: 43,
    questao_id: 11,
    opcao: '4ª',
    discriminacao: '> 75%. ',
    resposta_gestor: false,
    pontos: 3
  },
  44: {
    id: 44,
    questao_id: 12,
    opcao: '1ª',
    discriminacao: 'Não informado ou não realizado.',
    resposta_gestor: true,
    pontos: 0
  },
  45: {
    id: 45,
    questao_id: 12,
    opcao: '2ª',
    discriminacao: 'Utilização pontual de alguma ferramenta.',
    resposta_gestor: false,
    pontos: 1
  },
  46: {
    id: 46,
    questao_id: 12,
    opcao: '3ª',
    discriminacao: 'Utilização de ferramentas sólidas, porém, restrita a alguns riscos.',
    resposta_gestor: false,
    pontos: 2
  },
  47: {
    id: 47,
    questao_id: 12,
    opcao: '4ª',
    discriminacao:
      'Utilização de softawares consagrados e abrangendo a totalidade ou os riscos de maior relevância.',
    resposta_gestor: false,
    pontos: 3
  },
  48: {
    id: 48,
    questao_id: 13,
    opcao: '1ª',
    discriminacao:
      'Não mencionada, não utilizada, abandonada ou fragilizada  em relação ao que havia.',
    resposta_gestor: true,
    pontos: 0
  },
  49: {
    id: 49,
    questao_id: 13,
    opcao: '2ª',
    discriminacao: 'Uso limitado, com baixo nível de aderência e avanços  tecnológicos.',
    resposta_gestor: false,
    pontos: 1
  },
  50: {
    id: 50,
    questao_id: 13,
    opcao: '3ª',
    discriminacao: 'Utilização de métodos com satisfatório grau de aderência.',
    resposta_gestor: false,
    pontos: 2
  },
  51: {
    id: 51,
    questao_id: 13,
    opcao: '4ª',
    discriminacao: 'Utilização de métodos consagrados, com sólidas evidências  de efetividade.',
    resposta_gestor: false,
    pontos: 3
  },
  52: {
    id: 52,
    questao_id: 14,
    opcao: '1ª',
    discriminacao:
      'Não mencionada, não utilizada, abandonada ou fragilizada  em relação ao que havia.',
    resposta_gestor: true,
    pontos: 0
  },
  53: {
    id: 53,
    questao_id: 14,
    opcao: '2ª',
    discriminacao: 'Utilização limitada, com baixo nível de aderência e avanços  tecnológicos.',
    resposta_gestor: false,
    pontos: 1
  },
  54: {
    id: 54,
    questao_id: 14,
    opcao: '3ª',
    discriminacao: 'Utilização de métodos com satisfatório grau de aderência.',
    resposta_gestor: false,
    pontos: 2
  },
  55: {
    id: 55,
    questao_id: 14,
    opcao: '4ª',
    discriminacao: 'Utilização de métodos consagrados, com sólidas evidências  de efetividade.',
    resposta_gestor: false,
    pontos: 3
  },
  56: {
    id: 56,
    questao_id: 15,
    opcao: '1ª',
    discriminacao:
      'Não mencionada, não utilizada, abandonada ou fragilizada  em relação ao que havia.',
    resposta_gestor: true,
    pontos: 0
  },
  57: {
    id: 57,
    questao_id: 15,
    opcao: '2ª',
    discriminacao: 'Uso limitado, c/baixo nível de aderência e avanços tecnológicos.',
    resposta_gestor: false,
    pontos: 1
  },
  58: {
    id: 58,
    questao_id: 15,
    opcao: '3ª',
    discriminacao: 'Utilização de métodos com satisfatório grau de aderência.',
    resposta_gestor: false,
    pontos: 2
  },
  59: {
    id: 59,
    questao_id: 15,
    opcao: '4ª',
    discriminacao: 'Uso de métodos consagrados, com sólidas evidências de efetividade.',
    resposta_gestor: false,
    pontos: 3
  },
  60: {
    id: 60,
    questao_id: 16,
    opcao: '1ª',
    discriminacao:
      'Não mencionada, não utilizada, abandonada ou fragilizada  em relação ao que havia.',
    resposta_gestor: true,
    pontos: 0
  },
  61: {
    id: 61,
    questao_id: 16,
    opcao: '2ª',
    discriminacao: 'Uso limitado, c/baixo nível de aderência e avanços tecnológicos.',
    resposta_gestor: false,
    pontos: 1
  },
  62: {
    id: 62,
    questao_id: 16,
    opcao: '3ª',
    discriminacao: 'Utilização de métodos com satisfatório grau de aderência.',
    resposta_gestor: false,
    pontos: 2
  },
  63: {
    id: 63,
    questao_id: 16,
    opcao: '4ª',
    discriminacao: 'Uso de métodos consagrados, com sólidas evidências de efetividade.',
    resposta_gestor: false,
    pontos: 3
  },
  64: {
    id: 64,
    questao_id: 17,
    opcao: '1ª',
    discriminacao:
      'Não mencionada, não utilizada, abandonada ou fragilizada em relação ao que havia',
    resposta_gestor: true,
    pontos: 1
  },
  65: {
    id: 65,
    questao_id: 17,
    opcao: '2ª',
    discriminacao: 'Uso limitado, c/ baixo nível de aderência e avanços tecnológicos.',
    resposta_gestor: false,
    pontos: 2
  },
  66: {
    id: 66,
    questao_id: 17,
    opcao: '3ª',
    discriminacao: 'Utilização de métodos com satisfatório grau de aderência.',
    resposta_gestor: false,
    pontos: 3
  },
  67: {
    id: 67,
    questao_id: 17,
    opcao: '4ª',
    discriminacao: 'Uso de métodos consagrados, com sólidas evidências de efetividade.',
    resposta_gestor: false,
    pontos: 4
  },
  68: {
    id: 68,
    questao_id: 18,
    opcao: '1ª',
    discriminacao: 'Não fornece.',
    resposta_gestor: true,
    pontos: 0
  },
  69: {
    id: 69,
    questao_id: 18,
    opcao: '2ª',
    discriminacao: 'Fornecimento esporádico e com conteúdo mínimo. ',
    resposta_gestor: false,
    pontos: 1
  },
  70: {
    id: 70,
    questao_id: 18,
    opcao: '3ª',
    discriminacao: 'Fornecimento regular com conteúdo satisfatório. ',
    resposta_gestor: false,
    pontos: 2
  },
  71: {
    id: 71,
    questao_id: 18,
    opcao: '4ª',
    discriminacao: 'Fornecimento regular, c/ dados de elevado grau de importância. ',
    resposta_gestor: false,
    pontos: 3
  },
  72: {
    id: 72,
    questao_id: 19,
    opcao: 'Sim',
    discriminacao:
      'Na hipótese de a instituição gestora exercer, exclusivamente, atividade de gestão de fundos.',
    resposta_gestor: true,
    pontos: 3
  },
  73: {
    id: 73,
    questao_id: 19,
    opcao: 'Não',
    discriminacao:
      'Na hipótese de a instituição gestora oferecer, também, serviços de administração, custódia, distribuição etc. [ainda que por meio de ligadas/coligadas].',
    resposta_gestor: false,
    pontos: 0
  },
  74: {
    id: 74,
    questao_id: 20,
    opcao: 'Sim',
    discriminacao:
      'Na hipótese de gestora, sócios e/ou gestores serem cotistas do fundo avaliado ou de fundo da gestora que compartilha a mesma estratégia.',
    resposta_gestor: true,
    pontos: 3
  },
  75: {
    id: 75,
    questao_id: 20,
    opcao: 'Não',
    discriminacao: 'Na hipótese contrária',
    resposta_gestor: false,
    pontos: 1
  },
  76: {
    id: 76,
    questao_id: 21,
    opcao: '1ª',
    discriminacao: 'Não mencionado ou inexistente.',
    resposta_gestor: true,
    pontos: 0
  },
  77: {
    id: 77,
    questao_id: 21,
    opcao: '2ª',
    discriminacao: 'Atuação pontual.',
    resposta_gestor: false,
    pontos: 1
  },
  78: {
    id: 78,
    questao_id: 21,
    opcao: '3ª',
    discriminacao: 'Atuação em vários pontos de risco.',
    resposta_gestor: false,
    pontos: 2
  },
  79: {
    id: 79,
    questao_id: 21,
    opcao: '4ª',
    discriminacao:
      'Atuação efetiva em todos os níveis de risco, dentro de elevados critérios de governança e PLDFT.',
    resposta_gestor: false,
    pontos: 3
  },
  80: {
    id: 80,
    questao_id: 22,
    opcao: '1ª',
    discriminacao: 'Não informado ou inexistente. ',
    resposta_gestor: true,
    pontos: 0
  },
  81: {
    id: 81,
    questao_id: 22,
    opcao: '2ª',
    discriminacao: 'Política informal e/ou com baixo nível de mitigação de risco de agência.',
    resposta_gestor: false,
    pontos: 1
  },
  82: {
    id: 82,
    questao_id: 22,
    opcao: '3ª',
    discriminacao: 'Política formalizada, com moderado nível de mitigação de risco de agência.',
    resposta_gestor: true,
    pontos: 2
  },
  83: {
    id: 83,
    questao_id: 22,
    opcao: '4ª',
    discriminacao: 'Política formal com elevado nível de mitigação de risco de agência.',
    resposta_gestor: false,
    pontos: 3
  },
  84: {
    id: 84,
    questao_id: 23,
    opcao: 'Sim',
    discriminacao: 'A equipe de risco recebe remuneração atrelada à performace do fundo.',
    resposta_gestor: true,
    pontos: 0
  },
  85: {
    id: 85,
    questao_id: 23,
    opcao: 'Não',
    discriminacao: 'A equipe de risco não recebe remuneração atrelada à performace do fundo.',
    resposta_gestor: false,
    pontos: 3
  },
  86: {
    id: 86,
    questao_id: 24,
    opcao: '1ª',
    discriminacao:
      'Na hipótese de gestora, administradora e custodiante pertencentes a mesmo grupo econômico.',
    resposta_gestor: true,
    pontos: -3
  },
  87: {
    id: 87,
    questao_id: 24,
    opcao: '2ª',
    discriminacao:
      'Na hipótese de apenas a gestora ser instituição não pertencente a um mesmo grupo econômico.',
    resposta_gestor: false,
    pontos: 1.5
  },
  88: {
    id: 88,
    questao_id: 24,
    opcao: '3ª',
    discriminacao:
      'Na hipótese de gestora, administradora e custodiante não pertencentes a um mesmo grupo econômico.',
    resposta_gestor: false,
    pontos: 3
  },
  89: {
    id: 89,
    questao_id: 25,
    opcao: '1ª',
    discriminacao: 'Inobservância dos aspectos ASG nos processos de investimentos do fundo.',
    resposta_gestor: true,
    pontos: 0
  },
  90: {
    id: 90,
    questao_id: 25,
    opcao: '2ª',
    discriminacao:
      'Baixo nível de formalização de aspectos ASG nos processos de investimentos do fundo, sem evidência de processos.',
    resposta_gestor: false,
    pontos: 1
  },
  91: {
    id: 91,
    questao_id: 25,
    opcao: '3ª',
    discriminacao:
      'Políticas / Normativos Internos sobre aspectos ASG formalizados, porém, com baixo nível de evidência de efetiva incorporação nos processos de investimentos.',
    resposta_gestor: false,
    pontos: 2
  },
  92: {
    id: 92,
    questao_id: 25,
    opcao: '4ª',
    discriminacao:
      'Políticas / Normativos Internos sobre aspectos ASG formalizados e devidamente incorporados nos processos de investimentos, contemplando critérios ou scores que, uma vez não observados, implicam em vedação ou restringem a alocação do ativo ou que, uma vez observados, incentivam a alocação do ativo.',
    resposta_gestor: false,
    pontos: 3
  },
  93: {
    id: 93,
    questao_id: 26,
    opcao: 'Sim',
    discriminacao: 'Gestora signatária do PRI ou equivalentes.',
    resposta_gestor: true,
    pontos: 3
  },
  94: {
    id: 94,
    questao_id: 26,
    opcao: 'Não',
    discriminacao: 'Gestora não signatária do PRI ou equivalentes.',
    resposta_gestor: false,
    pontos: 1.5
  },
  95: {
    id: 95,
    questao_id: 27,
    opcao: 'Sim',
    discriminacao: 'A gestora é aderente.',
    resposta_gestor: true,
    pontos: 3
  },
  96: {
    id: 96,
    questao_id: 27,
    opcao: 'Não',
    discriminacao: 'A gestora não é aderente.',
    resposta_gestor: false,
    pontos: 0
  },
  97: {
    id: 97,
    questao_id: 28,
    opcao: '1ª',
    discriminacao: 'Mais de 6 não conformidades na gestora.',
    resposta_gestor: true,
    pontos: 0
  },
  98: {
    id: 98,
    questao_id: 28,
    opcao: '2ª',
    discriminacao: 'De 4 a 6 não conformidades na gestora.',
    resposta_gestor: false,
    pontos: 1
  },
  99: {
    id: 99,
    questao_id: 28,
    opcao: '3ª',
    discriminacao: 'De 1 a 3 não conformidades na gestora.',
    resposta_gestor: false,
    pontos: 2
  },
  100: {
    id: 100,
    questao_id: 28,
    opcao: '4ª',
    discriminacao:
      'Ausência de não conformidade regulatória no background  check da instituição gestora.',
    resposta_gestor: false,
    pontos: 3
  },
  101: {
    id: 101,
    questao_id: 29,
    opcao: '1ª',
    discriminacao: 'Mais de 6 não conformidades na administradora.',
    resposta_gestor: true,
    pontos: 0
  },
  102: {
    id: 102,
    questao_id: 29,
    opcao: '2ª',
    discriminacao: 'De 4 a 6 não conformidades na administradora.',
    resposta_gestor: false,
    pontos: 1
  },
  103: {
    id: 103,
    questao_id: 29,
    opcao: '3ª',
    discriminacao: 'De 1 a 3 não conformidades na administradora.',
    resposta_gestor: false,
    pontos: 2
  },
  104: {
    id: 104,
    questao_id: 29,
    opcao: '4ª',
    discriminacao:
      'Ausência de não conformidade regulatória no background  check da instituição administradora.',
    resposta_gestor: false,
    pontos: 3
  },
  105: {
    id: 105,
    questao_id: 30,
    opcao: '1ª',
    discriminacao: 'Mais de 6 não conformidades na custodiante.',
    resposta_gestor: true,
    pontos: 0
  },
  106: {
    id: 106,
    questao_id: 30,
    opcao: '2ª',
    discriminacao: 'De 4 a 6 não conformidades na custodiante.',
    resposta_gestor: false,
    pontos: 1
  },
  107: {
    id: 107,
    questao_id: 30,
    opcao: '3ª',
    discriminacao: 'De 1 a 3 não conformidades na custodiante.',
    resposta_gestor: false,
    pontos: 2
  },
  108: {
    id: 108,
    questao_id: 30,
    opcao: '4ª',
    discriminacao:
      'Ausência de não conformidade regulatória no background  check da instituição custodiante.',
    resposta_gestor: false,
    pontos: 3
  },
  109: {
    id: 109,
    questao_id: 31,
    opcao: 'Sim',
    discriminacao: 'O fundo segue para análise.',
    resposta_gestor: true,
    pontos: null
  },
  110: {
    id: 110,
    questao_id: 31,
    opcao: 'Não',
    discriminacao:
      'Neste caso, a governança de investimentos da EFPC deve prever, em seus normativos internos, se a alocação no fundo fica vetada ou se segue com limitação.',
    resposta_gestor: false,
    pontos: null
  },
  111: {
    id: 111,
    questao_id: 32,
    opcao: 'Não',
    discriminacao: 'Na hipótese de o fundo aceitar investidores em geral.',
    resposta_gestor: true,
    pontos: 2
  },
  112: {
    id: 112,
    questao_id: 32,
    opcao: 'Sim',
    discriminacao:
      'Na hipótese de o fundo aceitar, exclusivamente, investidores qualificados ou previdenciários.',
    resposta_gestor: false,
    pontos: 3
  },
  113: {
    id: 113,
    questao_id: 33,
    opcao: '1ª',
    discriminacao: 'TMA > 3% a.a.',
    resposta_gestor: true,
    pontos: 0
  },
  114: {
    id: 114,
    questao_id: 33,
    opcao: '2ª',
    discriminacao: '2% aa ≤ TMA ≤ 3% aa.',
    resposta_gestor: false,
    pontos: 1
  },
  115: {
    id: 115,
    questao_id: 33,
    opcao: '3ª',
    discriminacao: '1,5% aa ≤ TMA ≤ 2% aa.',
    resposta_gestor: false,
    pontos: 2
  },
  116: {
    id: 116,
    questao_id: 33,
    opcao: '4ª',
    discriminacao: 'TMA < 1,5% aa.',
    resposta_gestor: false,
    pontos: 3
  },
  117: {
    id: 117,
    questao_id: 34,
    opcao: 'Não',
    discriminacao: 'Na hipótese de admissão de operações com derivativos para posicionamento.',
    resposta_gestor: true,
    pontos: 0
  },
  118: {
    id: 118,
    questao_id: 34,
    opcao: 'Sim',
    discriminacao:
      'Na hipótese de admissão, exclusivamente, de operações com derivativos para hedge ou proteção da carteira do fundo.',
    resposta_gestor: false,
    pontos: 3
  },
  119: {
    id: 119,
    questao_id: 35,
    opcao: 'Sim',
    discriminacao: 'Na hipótese de vedação explícita de títulos de crédito privado.',
    resposta_gestor: true,
    pontos: 3
  },
  120: {
    id: 120,
    questao_id: 35,
    opcao: 'Não',
    discriminacao: 'Na hipótese contrária.',
    resposta_gestor: false,
    pontos: 0
  },
  121: {
    id: 121,
    questao_id: 36,
    opcao: 'Não',
    discriminacao: 'Na hipótese contrária.',
    resposta_gestor: false,
    pontos: 0
  },
  122: {
    id: 122,
    questao_id: 36,
    opcao: 'Sim',
    discriminacao: 'Na hipótese de vedação ou restrição explícita de alocação.',
    resposta_gestor: true,
    pontos: 3
  }
};

export default AVALIACAO_DISCRIMINACOES;
